import { createFileRoute } from "@tanstack/react-router";

import { ProductSettingsPage } from "@/features/settings/product/product-settings-page";

export const Route = createFileRoute("/settings/product")({
  component: ProductSettingsPage,
});
